import { render, staticRenderFns } from "./BudgetReport.vue?vue&type=template&id=94352474&scoped=true"
import script from "./BudgetReport.vue?vue&type=script&lang=js"
export * from "./BudgetReport.vue?vue&type=script&lang=js"
import style0 from "./BudgetReport.vue?vue&type=style&index=0&id=94352474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94352474",
  null
  
)

export default component.exports